import React, { Component } from "react";
import Fade from "react-reveal";

class Footer extends Component {
  render() {
    if (!this.props.data) return null;

    const profilepic = "images/doomidoo-logo@1x.png";

    const networks = this.props.data.social.map(function (network) {
      return (
        <li key={network.name}>
          <a href={network.url}>
            <i className={network.className}></i>
          </a>
        </li>
      );
    });

    return (
      <footer id="footer">
        <div className="row">
          <Fade bottom>
            <div className="twelve columns">
            <img
                className="profile-pic"
                src={profilepic}
                alt="DD Marasem"
              />
            </div>
            <div className="twelve columns">
              <ul className="social-links">{networks}</ul>

              <ul className="copyright" dir="ltr">
                <li>&copy; Copyright 2025 DD Marasem</li>
              </ul>
            </div>
          </Fade>

          <div id="go-top">
            <a className="smoothscroll" title="Back to Top" href="#home">
              <i className="icon-up-open"></i>
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

     /*  {
        "name":"github",
        "url":"https://github.com/nordicgiant2/react-nice-resume",
        "className":"fa fa-github"
      } */
export default Footer;
